import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=3557b923&scoped=true&"
import script from "./Text.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Text.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Text.vue?vue&type=style&index=0&id=3557b923&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3557b923",
  null
  
)

export default component.exports